import { buttons } from "@icarros/theme-react";
export const { sizes, types } = buttons;
export var MainVariants;
(function (MainVariants) {
    MainVariants["primary"] = "primary";
    MainVariants["secondary"] = "secondary";
})(MainVariants || (MainVariants = {}));
export var MainPaddingSize;
(function (MainPaddingSize) {
    MainPaddingSize["xsmall"] = "xsmall";
    MainPaddingSize["small"] = "small";
    MainPaddingSize["default"] = "default";
})(MainPaddingSize || (MainPaddingSize = {}));
//# sourceMappingURL=constants.js.map